import { Suspense } from 'react';
import { Tabs, useTabs } from '@common';
import { VenueDetailsHeader } from '@features';
import { Loader } from '@mantine/core';
import { PageLayout } from '@pages';
import { Outlet } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { Route } from 'src/routes/_rootLayout/venues/$id';
import { tabs } from './data';

type ActiveTab =
  | 'general'
  | 'shows'
  | 'holds'
  | 'overview'
  | 'rental'
  | 'files'
  | 'reports';

export const VenueDetailsPage: React.FC = () => {
  const { t } = useTranslation('venueDetails');
  const { id } = Route.useParams();
  const { activeTab, allowedTabs } = useTabs(tabs);

  return (
    <PageLayout
      title={
        <Suspense fallback={<Loader size="xs" color="white" />}>
          <VenueDetailsHeader />
        </Suspense>
      }
    >
      <Tabs<ActiveTab> value={activeTab ?? 'general'}>
        <Tabs.TabsList>
          {allowedTabs.map((tab) => (
            <Tabs.Tab
              to={`/venues/$id/${tab.value}`}
              params={{ id }}
              key={tab.value}
              value={tab.value}
            >
              {t(`TABS.${tab.labelKey}`)}
            </Tabs.Tab>
          ))}
        </Tabs.TabsList>
      </Tabs>
      <Outlet />
    </PageLayout>
  );
};
